import React from "react";
import { Col, Form, Input, InputNumber, Radio } from "antd";

import DatePicker from "@components/ResponsiveDatePicker";
import Select from "@components/ResponsiveSelect";
import {
  normalizeEquipmentCategoryForms,
  parseEquipmentCategoryFormOptions,
} from "@/utils/equipment-category-forms";

const requiredRule = {
  validator: (_, value) => (
    value === undefined || value === null || value === ""
      ? Promise.reject(new Error("This field is required"))
      : Promise.resolve()
  ),
};

const renderControl = (definition, readOnly) => {
  switch (definition.formType) {
    case "number":
      return <InputNumber disabled={readOnly} style={{ width: "100%" }} />;
    case "boolean":
      return (
        <Radio.Group disabled={readOnly}>
          {!definition.require && <Radio value="">Not set</Radio>}
          <Radio value={true}>Yes</Radio>
          <Radio value={false}>No</Radio>
        </Radio.Group>
      );
    case "select":
      return (
        <Select
          disabled={readOnly}
          allowClear
          options={parseEquipmentCategoryFormOptions(definition.extra).map((option) => ({
            label: option,
            value: option,
          }))}
        />
      );
    case "textarea":
      return <Input.TextArea disabled={readOnly} rows={3} />;
    case "date":
      return <DatePicker disabled={readOnly} format="YYYY-MM-DD" style={{ width: "100%" }} />;
    case "text":
    default:
      return <Input disabled={readOnly} />;
  }
};

const EquipmentDynamicFields = ({ forms, readOnly = false }) => {
  const definitions = normalizeEquipmentCategoryForms(forms);
  if (!definitions.length) return null;

  return (
    <>
      <Col xs={24} />
      {definitions.map((definition) => (
        <Col xs={24} lg={12} key={definition.label}>
          <Form.Item
            label={definition.unit ? `${definition.label} (${definition.unit})` : definition.label}
            name={["form_values", definition.label]}
            extra={definition.description || undefined}
            rules={definition.require ? [requiredRule] : []}
          >
            {renderControl(definition, readOnly)}
          </Form.Item>
        </Col>
      ))}
    </>
  );
};

export default EquipmentDynamicFields;
